import React, { useState, useEffect } from "react";
import * as styles from "./styles.module.scss";
import cn from "classnames";
import { useWindowSize } from "~hooks";
import Image from "../Image";

const PartnerCard = ({
  name,
  link,
  infoText,
  logo,
  setShowInfoModal,
  setInfoModalContent
}) => {
  const [showInfoSlideUp, setShowInfoSlideUp] = useState(false);

  const Element = link ? "a" : "div";

  const { width } = useWindowSize();

  const maxUseModalWidth = 600;
  const useModal = width <= maxUseModalWidth;

  const handleShowInfo = () => {
    if (useModal) {
      setShowInfoModal(true);
      setInfoModalContent(infoText);
      return;
    }

    setShowInfoSlideUp(true);
  };

  useEffect(() => {
    if (!useModal) {
      setShowInfoModal(false);
    }

    if (useModal) {
      setShowInfoSlideUp(false);
    }
  }, [useModal]);

  return (
    <div className={styles.container}>
      <Element href={link} rel="noopener noreferrer" className={styles.content}>
        <div className={styles.imageContainer}>
          <Image image={logo} alt={name} />
        </div>
      </Element>

      {infoText && (
        <button
          onClick={handleShowInfo}
          className={cn(styles.button, styles.showInfoButton)}
        >
          <div className={styles.buttonIcon}>
            <InfoSVG />
          </div>
        </button>
      )}

      {infoText && (
        <div
          className={cn(styles.infoContainer, {
            [styles.active]: showInfoSlideUp
          })}
        >
          <div className={styles.closeInfoButtonContainer}>
            <button
              onClick={() => setShowInfoSlideUp(false)}
              className={cn(styles.button, styles.closeInfoButton)}
            >
              <div className={styles.buttonIcon}>
                <XSVG />
              </div>
            </button>
          </div>
          <p>{infoText}</p>
        </div>
      )}
    </div>
  );
};

export default PartnerCard;

const InfoSVG = () => (
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.99935 1.99996C4.68564 1.99996 1.99935 4.68625 1.99935 7.99996C1.99935 11.3137 4.68564 14 7.99935 14C11.3131 14 13.9993 11.3137 13.9993 7.99996C13.9993 4.68625 11.3131 1.99996 7.99935 1.99996ZM0.666016 7.99996C0.666016 3.94987 3.94926 0.666626 7.99935 0.666626C12.0494 0.666626 15.3327 3.94987 15.3327 7.99996C15.3327 12.05 12.0494 15.3333 7.99935 15.3333C3.94926 15.3333 0.666016 12.05 0.666016 7.99996ZM7.33268 5.33329C7.33268 4.9651 7.63116 4.66663 7.99935 4.66663H8.00602C8.37421 4.66663 8.67268 4.9651 8.67268 5.33329C8.67268 5.70148 8.37421 5.99996 8.00602 5.99996H7.99935C7.63116 5.99996 7.33268 5.70148 7.33268 5.33329ZM7.99935 7.33329C8.36754 7.33329 8.66602 7.63177 8.66602 7.99996V10.6666C8.66602 11.0348 8.36754 11.3333 7.99935 11.3333C7.63116 11.3333 7.33268 11.0348 7.33268 10.6666V7.99996C7.33268 7.63177 7.63116 7.33329 7.99935 7.33329Z"
      fill="currentColor"
    />
  </svg>
);

const XSVG = () => (
  <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.52827 0.528636C0.788619 0.268287 1.21073 0.268287 1.47108 0.528636L4.99967 4.05723L8.52827 0.528636C8.78862 0.268287 9.21073 0.268287 9.47108 0.528636C9.73143 0.788986 9.73143 1.2111 9.47108 1.47145L5.94248 5.00004L9.47108 8.52864C9.73143 8.78899 9.73143 9.2111 9.47108 9.47145C9.21073 9.7318 8.78862 9.7318 8.52827 9.47145L4.99967 5.94285L1.47108 9.47145C1.21073 9.7318 0.788619 9.7318 0.52827 9.47145C0.26792 9.2111 0.26792 8.78899 0.52827 8.52864L4.05687 5.00004L0.52827 1.47145C0.26792 1.2111 0.26792 0.788986 0.52827 0.528636Z"
      fill="currentColor"
    />
  </svg>
);
